import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RestClientService} from './rest-client/rest-client.service';
import {UsCity} from './model/us-city';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UsCityService {

  constructor(private restClient: RestClientService) {
  }

  public getAll(text: string): Observable<UsCity[]> {
    const params = new HttpParams().append('text', text);
    return this.restClient.getWithParams<UsCity[]>(`/us-cities`, params);
  }
}
